import { clearStage, clearModule } from '../../../redux/actions/logActions';

export const resetCountryButtons = (dispatch) => {
  dispatch(clearModule());
  dispatch(clearStage());
};

export const resetStateAndOverlay = (setLockChecked, setDevChecked, dialogProps) => {
  setLockChecked(false);
  setDevChecked(false);
  dialogProps.setShowOverlay(true);
};

export const handleModuleTypeLogChange = (type, dialogProps, index) => {
  if (dialogProps.eldData[0].length !== 0) {
    switch (type) {
      case 'FtF':
        return dialogProps.eldData[0].countries[index].ftf.sort((a, b) => a.name.localeCompare(b.name));
      case 'FtF_2.0':
        return dialogProps.eldData[0].countries[index].ftf_2_0.sort((a, b) => a.name.localeCompare(b.name));
      case 'Logistics':
        return dialogProps.eldData[0].countries[index].logistics.sort((a, b) => a.name.localeCompare(b.name));
      case 'MA':
        return dialogProps.eldData[0].countries[index].ma.sort((a, b) => a.name.localeCompare(b.name));
      case 'MA_2.0':
        return dialogProps.eldData[0].countries[index].ma.sort((a, b) => a.name.localeCompare(b.name));
      case 'MA_3.0':
        return dialogProps.eldData[0].countries[index].ma.sort((a, b) => a.name.localeCompare(b.name));
      case 'Nugget AUDI':
        return dialogProps.eldData[0].countries[index].nugget_audi.sort((a, b) => a.name.localeCompare(b.name));
      case 'Nugget INT':
        return dialogProps.eldData[0].countries[index].nugget_int.sort((a, b) => a.name.localeCompare(b.name));
      case 'Other':
        return dialogProps.eldData[0].countries[index].other.sort((a, b) => a.name.localeCompare(b.name));
      default:
        return dialogProps.eldData[0].countries[0].ftf.sort((a, b) => a.name.localeCompare(b.name));
    }
  }
};

export const showMsg = (toast, dictionary) => {
  toast.current.show({
    severity: 'warn',
    summary: dictionary.toast_summary_warn,
    detail: dictionary.toast_create_log_detail,
    life: 7000,
  });
};

export const versions = [
  { name: '1.0' },
  { name: '1.1' },
  { name: '1.2' },
  { name: '1.3' },
  { name: '1.4' },
  { name: '1.5' },
  { name: '1.6' },
  { name: '1.7' },
  { name: '1.8' },
  { name: '1.9' },
  { name: '1.10' },
];
